import { Icon } from '@/components/ui/Icon';
import { TextInput } from '@/components/ui';

/** רכיבים משותפים לקודי סיום ותגיות שיחה — סגנון ה-mockup (Jul 2026). */

export const TAG_PRESETS = ['#db2777', '#0891b2', '#6366f1', '#6b7280', '#dc2626', '#2563eb', '#f59e0b', '#16a34a'];

/** תווית בטבלה: כרטיסון לבן עם נקודת צבע עגולה. */
export function LabelPill({ color, label }: { color: string; label: string }) {
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 7, padding: '2px 9px',
      borderRadius: 'var(--r-2)', background: 'var(--surface)', border: '1px solid var(--line)',
      boxShadow: 'var(--shadow-1)', fontWeight: 500, fontSize: 'var(--t-sm)',
    }}>
      <span aria-hidden style={{ width: 10, height: 10, borderRadius: '50%', background: color, display: 'inline-block', flexShrink: 0 }} />
      {label}
    </span>
  );
}

/** פס פעולות: חיפוש עם אייקון + כפתור יצירה ראשי. */
export function TagActionBar({ search, onSearch, placeholder, createLabel, onCreate }: {
  search: string;
  onSearch: (v: string) => void;
  placeholder: string;
  createLabel: string;
  onCreate: () => void;
}) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap' }}>
      <div style={{ position: 'relative', width: 288, maxWidth: '100%' }}>
        <span style={{ position: 'absolute', insetInlineStart: 10, top: '50%', transform: 'translateY(-50%)', color: 'var(--muted)', pointerEvents: 'none', display: 'inline-flex' }}>
          <Icon name="search" size={15} />
        </span>
        <TextInput value={search} onChange={(e) => onSearch(e.target.value)} placeholder={placeholder} style={{ width: '100%', paddingInlineStart: 32 }} />
      </div>
      <button type="button" className="btn primary" onClick={onCreate}>{createLabel}</button>
    </div>
  );
}

/** בוחר צבע: עיגולים עם טבעת על הנבחר + עיגול מותאם-אישית (color input). */
export function ColorDots({ value, onChange }: { value: string; onChange: (c: string) => void }) {
  const isPreset = TAG_PRESETS.some((c) => c.toLowerCase() === value.toLowerCase());
  return (
    <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
      <style>{`.tag-color-dot{transition:transform .12s ease}.tag-color-dot:hover{transform:scale(1.12)}`}</style>
      {TAG_PRESETS.map((c) => {
        const active = value.toLowerCase() === c.toLowerCase();
        return (
          <button
            key={c}
            type="button"
            className="tag-color-dot"
            onClick={() => onChange(c)}
            aria-label={`צבע ${c}`}
            aria-pressed={active}
            style={{
              width: 28, height: 28, borderRadius: '50%', background: c, cursor: 'pointer',
              border: 'none', boxShadow: active
                ? `0 0 0 2px var(--surface), 0 0 0 4px ${c}`
                : 'var(--shadow-1)',
            }}
          />
        );
      })}
      {/* צבע חופשי — עיגול עם גלגל צבעים */}
      <label
        className="tag-color-dot"
        aria-label="צבע מותאם אישית"
        style={{
          width: 28, height: 28, borderRadius: '50%', cursor: 'pointer', overflow: 'hidden', position: 'relative',
          background: isPreset ? 'conic-gradient(red, yellow, lime, cyan, blue, magenta, red)' : value,
          boxShadow: !isPreset
            ? `0 0 0 2px var(--surface), 0 0 0 4px ${value}`
            : 'var(--shadow-1)',
        }}
      >
        <input
          type="color"
          value={/^#[0-9a-fA-F]{6}$/.test(value) ? value : '#5a3df0'}
          onChange={(e) => onChange(e.target.value)}
          style={{ position: 'absolute', inset: 0, opacity: 0, cursor: 'pointer' }}
        />
      </label>
    </div>
  );
}
